import { format, isValid } from "date-fns";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";

const MaintenancePopup = ({ data, data1 = [] }) => {
  return (
    <div className="p-4 w-full">
      <div className={mainTable.grid3}>
        <InputText
          inputType="date"
          title="Date"
          classStar="text-red-500"
          name="date"
          disabled={true}
          content={
            data?.Date && isValid(new Date(data.Date))
              ? format(new Date(data.Date), "yyyy-MM-dd")
              : ""
          }
        />

        <AutoDropDown
          selectedOption={{
            value: data?.RoomType ?? "",
            label: data?.RoomType ?? "",
          }}
          title="Spaces"
          classStar={"text-red-500"}
          // inputType="dropdown"
          options={[]}
          name="spaces"
          disabled={true}
          placeholder="Room Type"
          Class="custom-class"
          // tabIndex="1"
          maxLength={50}
        />

        <AutoDropDown
          name="Room"
          classStar={"text-red-500"}
          title="Room Name"
          //  inputType="dropdown"
          option={[]}
          selectedOption={{
            value: data?.RoomName ?? "",
            label: data?.RoomName ?? "",
          }}
          placeholder="Select Room Name"
          //content={data.RoomName ||""}
          Class="custom-class"
          disabled={true}
        />

        <InputText
          title="Fixed Assets"
          type="text"
          name="mstFixedAssetId"
          placeholder="Fixed Assets"
          classStar={"text-red-500"}
          disabled={true}
          content={data?.ItemCategory ?? ""}
        />

        <InputText
          title="Issue"
          type="text"
          name="mstIssueTypeId"
          classStar={"text-red-500"}
          placeholder="Issue Type"
          disabled={true}
          content={data?.IssuesType ?? ""}
        />

        <InputText
          title="Amount"
          type="number"
          name="amount"
          classStar={"text-red-500"}
          placeholder="Amount"
          disabled={true}
          content={data?.Amount ?? ""}
        />

        <div className="col-span-2">
          {data?.FileUpload && (
            <div>
              <img
                src={data.FileUpload}
                alt="Supplier Logo"
                className="rounded-none w-20 h-20"
              />
            </div>
          )}

      

         
        </div>
      </div>
       <TextArea
            title="Remarks"
            name="remarks"
            placeholder="Remarks"
            content={data?.Remarks ?? ""}
            rows={3}
            disabled={true}
          />
    </div>
  );
};

export default MaintenancePopup;
